// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__ipp3Z","requiredAsterisk":"Info_requiredAsterisk__3a2tL"};